export default __webpack_public_path__ + "static/media/Text-1.1f922778.png";